import React, { Component } from 'react';
import './Nav.css';

class Nav extends Component {
    render() {
      return (
        <div className='nav-bar'>
          <div className='logo'>
            <h2 className='logo-text'>Animatic</h2>
          </div>
          <div className='nav-item-wrapper'>
            <h4 className='nav-item' onClick={this.props.resetHandler}>Reset</h4>
            <h4 className='nav-item' onClick={this.props.showModal}>Help</h4>
          </div>
        </div>
      )
    }
}

export default Nav;